export default __webpack_public_path__ + "img/551c8156b2c5769d20139bb9df0d6c6f.svg";